export const EnrichedEnum = {
  ERROR_NOT_ENRICHED: '0',
  ENRICHED: '2'
};

export const DefaultCustomer = {
  planName: '',
  segmentDesc: '',
  subSegment: '',
  segment: '',
  customer: '',
  loginType: '',
  timestamp: '01012000000000',
  lineType: '',
  exp: 0,
  document: '',
  planCode: '',
  name: '',
  login: '',
  imsi: '',
  planDesc: '',
  enriched: '0',
  isExOiCustomer: false
};
